import { httpCreate } from './http';

const http = httpCreate('/srv/free-invite-activity');

export const freeInviteActivity = {
	/**
	 * 创建活动 http://showdoc.srv.ourwill.cn/web/#/1?page_id=1823
	 * @param {*} data
	 */
	create(data) {
		return http.post('', data);
	},
	// 修改活动 http://showdoc.srv.ourwill.cn/web/#/1?page_id=1824
	update(data) {
		return http.put(`/${data.id}`, data);
	},
	// 获取列表 http://showdoc.srv.ourwill.cn/web/#/1?page_id=1825
	getList(params) {
		return http.get('', { params });
	},
	// 手动开启 http://showdoc.srv.ourwill.cn/web/#/1?page_id=1826
	open(id) {
		return http.put(`/open/${id}`);
	},
	// 手动关闭 http://showdoc.srv.ourwill.cn/web/#/1?page_id=1827
	close(id) {
		return http.put(`/close/${id}`);
	},
	// 删除活动 http://showdoc.srv.ourwill.cn/web/#/1?page_id=1828
	delete(id) {
		return http.delete(`/${id}`);
	},
};
